<template>
  <div class="member-management-page">
    <!-- 搜尋區 -->
    <div class="search-bar-top">
      <div class="search-input-container">
        <i class="fas fa-search search-icon"></i>
        <input type="text" placeholder="搜員工Email" v-model="searchQuery" />
      </div>
    </div>

    <!-- 功能區 -->
    <div class="action-buttons">
      <button class="action-button primary" @click="goToMemberList">
        回到員工清單
      </button>
      <button class="action-button primary" @click="showAddMemberModal">
        新增會員
      </button>
      <button class="action-button secondary" @click="filterBlacklist">
        停權名單
      </button>
    </div>

    <!-- 表格 -->
    <table class="member-table">
      <thead>
        <tr>
          <!-- ID 排序按鈕 -->
          <th @click="toggleSortOrder('id')" style="cursor: pointer">
            ID
            <i
              class="fas"
              :class="idSortOrder === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'"
              style="margin-left: 8px"
            ></i>
          </th>
          <th>Name</th>
          <th>Email</th>
          <th>電話</th>
          <th>生日</th>
          <th>國籍</th>
          <!-- 員工註冊日期排序按鈕 -->
          <th @click="toggleSortOrder('createdAt')" style="cursor: pointer">
            員工註冊日期
            <i
              class="fas"
              :class="dateSortOrder === 'asc' ? 'fa-arrow-up' : 'fa-arrow-down'"
              style="margin-left: 8px"
            ></i>
          </th>
          <th>封鎖狀態</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="member in paginatedMembers"
          :key="member.id"
          @click="showMemberDetails(member)"
          style="cursor: pointer"
        >
          <td>#{{ member.id }}</td>
          <td>{{ member.fullName }}</td>
          <td>{{ member.email }}</td>
          <td>{{ member.phone }}</td>
          <td>{{ formatDate(member.birth) }}</td>
          <td>{{ member.countries }}</td>
          <td>{{ formatDate(member.createdAt) }}</td>
          <td>
            <span
              class="status-tag"
              :class="member.locked ? 'blacklist' : 'whitelist'"
            >
              {{ member.locked ? "Blacklist" : "Whitelist" }}
            </span>
          </td>
          <td>
            <div class="btns">
              <!-- 刪除按鈕 -->
              <button
                class="btn btn-delete"
                @click.stop="deleteMember(member.id)"
              >
                刪除
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 分頁按鈕 -->
    <div class="pagination">
      <button class="page-btn" :disabled="!hasPreviousPage" @click="prevPage">
        « Previous
      </button>
      <button
        v-for="page in totalPages"
        :key="page"
        :class="['page-number', { active: page === currentPage }]"
        @click="goToPage(page)"
      >
        {{ page }}
      </button>
      <button class="page-btn" :disabled="!hasNextPage" @click="nextPage">
        Next »
      </button>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal">
        <!-- Header -->
        <div class="modal-header">
          <h2>員工資料</h2>
          <button class="close-button" @click="closeModal">×</button>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <!-- 員工資料表單 -->
          <div class="member-form">
            <div class="form-row">
              <div class="form-group">
                <label>員工名稱</label>
                <input
                  type="text"
                  v-model="selectedMember.fullName"
                  class="form-input"
                />
              </div>
              <div class="form-group">
                <label>員工電話</label>
                <input
                  type="text"
                  v-model="selectedMember.phone"
                  class="form-input"
                  :class="{
                    'input-error':
                    selectedMember.phone && !/^\d{10}$/.test(selectedMember.phone),
                  }"
                />
                <small
                  v-if="selectedMember.phone && !/^\d{10}$/.test(selectedMember.phone)"
                  class="error-text"
                >
                  電話號碼必須為 10 碼
                </small>
              </div>
              <div class="form-group">
                <label>員工Email</label>
                <input
                  type="email"
                  v-model="selectedMember.email"
                  class="form-input"
                  disabled
                  :class="{
                    'input-error':
                    selectedMember.email &&
                      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(selectedMember.email),
                      
                  }"
                />
                <small
                  v-if="
                    selectedMember.email &&
                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(selectedMember.email)
                  "
                  class="error-text"
                >
                  請輸入正確的 Email 格式
                </small>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>員工生日</label>
                <input
                  type="date"
                  v-model="selectedMember.birth"
                  class="form-input"
                  disabled
                />
              </div>
              <div class="form-group">
                <label>員工國籍</label>
                <input
                  type="text"
                  v-model="selectedMember.countries"
                  class="form-input"
                  disabled
                />
              </div>
              <div class="form-group">
                <label>員工權限</label>
                <select v-model="selectedMember.locked" class="form-input">
                  <option :value="false">正常</option>
                  <option :value="true">停權</option>
                </select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>員工建立日期</label>
                <input
                  type="date"
                  v-model="selectedMember.createdAt"
                  class="form-input"
                  disabled
                />
              </div>
            </div>
          </div>

          <!-- 更新按鈕 -->
          <button class="update-button" @click="saveMemberDetails">
            員工資料變更
          </button>

          
        </div>            
      </div>
    </div>

    <!-- 新增員工 Modal -->
    <div v-if="showAddModal" class="modal-overlay">
      <div class="modal">
        <div class="modal-header">
          <h2>新增員工</h2>
          <button class="close-button" @click="closeAddModal">×</button>
        </div>
        <div class="modal-body">
          <div class="member-form">
            <div class="form-row">
              <div class="form-group">
                <label>員工名稱</label>
                <input
                  type="text"
                  v-model="newMember.fullName"
                  class="form-input"
                />
              </div>
              <div class="form-group">
                <label>員工電話</label>
                <input
                  type="text"
                  v-model="newMember.phone"
                  class="form-input"
                  :class="{
                    'input-error':
                      newMember.phone && !/^\d{10}$/.test(newMember.phone),
                  }"
                />
                <small
                  v-if="newMember.phone && !/^\d{10}$/.test(newMember.phone)"
                  class="error-text"
                >
                  電話號碼必須為 10 碼
                </small>
              </div>
              <div class="form-group">
                <label>員工Email</label>
                <input
                  type="email"
                  v-model="newMember.email"
                  class="form-input"
                  :class="{
                    'input-error':
                      newMember.email &&
                      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newMember.email),
                  }"
                />
                <small
                  v-if="
                    newMember.email &&
                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newMember.email)
                  "
                  class="error-text"
                >
                  請輸入正確的 Email 格式
                </small>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label>員工生日</label>
                <input
                  type="date"
                  v-model="newMember.birth"
                  class="form-input"
                />
              </div>
              <div class="form-group">
                <label>員工權限</label>
                <select v-model="newMember.locked" class="form-input">
                  <option :value="false">正常</option>
                  <option :value="true">停權</option>
                </select>
              </div>
            </div>
            <button class="update-button" @click="addMember">新增會員</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="@/assets/css/background/employee.css" scoped></style>

<script>
import userManagementLogic from "@/assets/js/background/employee.js";

export default {
  name: "UserManagement",
  mixins: [userManagementLogic],
};
</script>
